import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Behandlungspflege = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const leistungen = [
    'An- und Ausziehen von Kompressionsstrümpfen',
    'Blutdruckmessung',
    'Blutzuckermessung',
    'Insulininjektionen',
    'Medikamentengabe und -überwachung',
    'Wundversorgung und Verbandswechsel',
    'Dekubitusprophylaxe und -versorgung',
    'Stomaversorgung',
    'Katheterversorgung',
    'Inhalationen',
    'Injektionen (subkutan, intramuskulär)'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden" data-testid="behandlungspflege-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <div className="text-6xl mb-6">⚕️</div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Behandlungspflege
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Medizinische Pflege durch qualifizierte Fachkräfte
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Was ist Behandlungspflege?
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Sie leiden an einer Krankheit und brauchen kompetente Unterstützung bei deren Behandlung? Vom Anziehen der Kompressionsstrümpfe, über die Blutdruckmessung bis hin zum Setzen von Insulinspritzen – Wir stehen Ihnen fachkundig zur Seite. Unsere examinierten Pflegefachkräfte führen alle ärztlich verordneten Maßnahmen professionell durch.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Unsere Leistungen im Bereich Behandlungspflege:
            </h3>
            <ul className="space-y-3 mb-8">
              {leistungen.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-turquoise-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="bg-gradient-to-br from-turquoise-50 to-turquoise-100 rounded-2xl p-6 mt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Kostenübernahme
              </h3>
              <p className="text-gray-700">
                Die Behandlungspflege wird vom Arzt verordnet und die Kosten werden von der Krankenkasse übernommen. Wir kümmern uns um die notwendigen Verordnungen und die Abrechnung mit Ihrer Krankenkasse.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-turquoise-400 to-turquoise-500 text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Interesse an unserer Behandlungspflege?
          </h2>
          <p className="text-xl mb-8">
            Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/angebot"
              className="bg-white text-turquoise-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-50 transition-all shadow-lg"
              data-testid="behandlungspflege-angebot-btn"
            >
              Angebot anfordern
            </Link>
            <a 
              href="tel:034124927833"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-turquoise-500 transition-all"
            >
              Jetzt anrufen
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Behandlungspflege;
